import React from 'react'

import { Table } from '_zari/core'

const MovimientosTable = ({ idDetalle, filas }) => {
  return (
    <Table
      containerId={`tabla-${idDetalle}`}
      filas={filas}
      headRows={[
        {
          label: 'FECHA'
        },
        {
          label: 'DOCUMENTO'
        },
        {
          label: 'ENTRADA'
        },
        {
          label: 'SALIDA'
        },
        {
          label: 'SALDO'
        }
      ]}
      rowTemplate={(row, k) => (
        <Table.Row key={k}>
          <Table.Cell>{row.fecha || '--'}</Table.Cell>
          <Table.Cell>{row.documento || '--'}</Table.Cell>
          <Table.Cell>{row.signo > 0 ? row.cantidad : '0'}</Table.Cell>
          <Table.Cell>{row.signo < 0 ? row.cantidad : '0'}</Table.Cell>
          <Table.Cell>{row.saldo || '0'}</Table.Cell>
        </Table.Row>
      )}
    />
  )
}

export default React.memo(MovimientosTable)
